module.exports = __webpack_public_path__ + "img/no-sprint-search.d344666a.svg";